import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

const STORAGE_KEY = 'visitCounted';

// Registra uma visita por sessão do navegador. As páginas do painel
// administrativo não contam, para o próprio uso da loja não inflar o número.
export default function VisitTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/tocadochefe')) return;

    try {
      if (sessionStorage.getItem(STORAGE_KEY)) return;
      // Marca antes de enviar: evita contagem dupla no StrictMode e em navegações rápidas.
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // Sem sessionStorage (modo privado restrito): conta mesmo assim.
    }

    api.post('/visits').catch(() => {});
  }, [pathname]);

  return null;
}
